import React from 'react';
import { AlertCircle, Camera, ArrowRight } from 'lucide-react';

interface PhotoValidationModalProps {
  isOpen: boolean;
  error: string;
  onRetake: () => void;
  onContinueAnyway: () => void;
}

const PhotoValidationModal: React.FC<PhotoValidationModalProps> = ({
  isOpen,
  error,
  onRetake,
  onContinueAnyway
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-xl p-6 max-w-md w-full shadow-xl animate-fade-in">
        <div className="text-center mb-6">
          <div className="w-12 h-12 bg-amber-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <AlertCircle className="w-6 h-6 text-amber-500" />
          </div>
          <h3 className="text-lg font-semibold text-gray-800 mb-2">
            Image Issue Detected
          </h3>
          <p className="text-gray-600 text-sm">{error}</p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={onRetake}
            className="flex-1 py-3 px-4 bg-[#07E5D1] text-white rounded-lg font-medium
                       hover:bg-[#06D4C2] transition-colors flex items-center justify-center gap-2"
          >
            <Camera className="w-4 h-4" />
            Retake Photo
          </button>
          <button
            onClick={onContinueAnyway}
            className="flex-1 py-3 px-4 bg-gray-100 text-gray-700 rounded-lg font-medium
                       hover:bg-gray-200 transition-colors flex items-center justify-center gap-2"
          >
            Continue Anyway
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PhotoValidationModal;
